import { render, staticRenderFns } from "./ToReleaseEdit.vue?vue&type=template&id=d58aaba6&scoped=true"
import script from "./ToReleaseEdit.vue?vue&type=script&lang=js"
export * from "./ToReleaseEdit.vue?vue&type=script&lang=js"
import style0 from "./ToReleaseEdit.vue?vue&type=style&index=0&id=d58aaba6&prod&scoped=true&lang=css"
import style1 from "./ToReleaseEdit.vue?vue&type=style&index=1&id=d58aaba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58aaba6",
  null
  
)

export default component.exports